import { createStore } from '@servicetitan/financing-utils-shared';
import { useState } from 'react';

export interface FinancedAmountState {
    saleAmount: number;
    downPayment: number;
}

function useFinancedAmount(
    initialState: FinancedAmountState = { saleAmount: 1000, downPayment: 0 },
) {
    const [{ saleAmount, downPayment }, setFinancedAmount] =
        useState<FinancedAmountState>(initialState);

    return {
        get financedAmount() {
            return saleAmount - downPayment;
        },
        saleAmount,
        downPayment,
        setFinancedAmount,
    };
}

export const FinancedAmountStore = createStore(useFinancedAmount);
